/* EclatDent — panier : quantités, suppression et upsell en AJAX (Section Rendering) */
(() => {
  if (window.__edcartInit) return;
  window.__edcartInit = true;

  function getRoot() { return document.querySelector('[data-edcart]'); }

  function rerender(sectionsHtml) {
    const root = getRoot();
    if (!root) return;
    const sectionId = root.dataset.sectionId;
    const html = sectionsHtml && sectionId ? sectionsHtml[sectionId] : null;
    if (!html) { window.location.reload(); return; }
    const tpl = document.createElement('div');
    tpl.innerHTML = html;
    const fresh = tpl.querySelector('[data-edcart]');
    if (fresh) root.replaceWith(fresh);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function setBusy(busy) {
    const root = getRoot();
    if (root) root.classList.toggle('is-busy', busy);
  }

  function changeLine(line, quantity) {
    const root = getRoot();
    if (!root) return;
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: root.dataset.sectionId }),
    }).then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then((data) => rerender(data.sections))
      .catch(() => { setBusy(false); alert(getRoot()?.dataset.tUpdateFail || 'Mise à jour impossible. Réessaie dans un instant.'); });
  }

  function addVariant(variantId) {
    const root = getRoot();
    if (!root) return;
    setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: root.dataset.sectionId }),
    }).then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then((data) => rerender(data.sections))
      .catch(() => { setBusy(false); alert(getRoot()?.dataset.tAddFail || 'Ajout impossible. Réessaie dans un instant.'); });
  }

  // Délégation : le contenu est remplacé à chaque mise à jour AJAX
  document.addEventListener('click', (e) => {
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    const qtyBtn = target.closest('[data-edcart-qty]');
    if (qtyBtn) { changeLine(qtyBtn.dataset.line, qtyBtn.dataset.quantity); return; }
    const addBtn = target.closest('[data-edcart-add]');
    if (addBtn) { addVariant(addBtn.dataset.variant); }
  });
})();
